import { CurrencyPipe } from '@angular/common';
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonCol, IonIcon, IonLabel, IonRow } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { EAvailabilityState, IFreightAvailable } from '@okcargo-apps/shared-domain';
import { AppTab } from '@okcargo-apps/shared-domain-ionic';
import { DateFnsModule } from 'ngx-date-fns';

@Component({
  selector: 'lib-freight-available-card',
  templateUrl: './freight-available-card.component.html',
  styleUrls: ['./freight-available-card.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IonIcon,
    IonLabel,
    IonCol,
    IonRow,
    RouterLink,
    RouterLinkActive,
    DateFnsModule,
    CurrencyPipe,
    TranslateModule,
  ],
})
export class FreightAvailableCardComponent {
  public readonly freight = input.required<IFreightAvailable>();

  protected AppTab = AppTab;

  protected readonly isFullyAvailable = computed(() => {
    return this.freight().available === EAvailabilityState.FULL;
  });

  protected readonly isAvailableWithConditions = computed(() => {
    return this.freight().available === EAvailabilityState.PARTIAL;
  });

  protected readonly isNotAvailable = computed(() => {
    return this.freight().available === EAvailabilityState.NO;
  });
  // constructor() {}
}
